
import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import apiUrl from "../Apiurl";

function ProdottiTradotti (props) {
    
    const [totaleProdotti, setTotaleProdotti] = useState(0);
    const [prodottiTradotti, setProdottiTradotti] = useState(0);

    useAuth0().getAccessTokenSilently().then(token => {
        const options = {headers: {Authorization: "Bearer "+token}};
        return Promise.all([
            fetch(apiUrl+"/prodotti/translate/prodcount", options)
                .then(resp => resp.json())
                .then(data => setTotaleProdotti(data)),
            fetch(apiUrl+"/prodotti/translate/tradprodcount", options)
                .then(resp => resp.json())
                .then(data => setProdottiTradotti(data))
        ])
    }).catch(err => {
        console.error('errore nel caricamento delle info sui prodotti', err);
    });

    return(
        <div>Tradotti <strong>{prodottiTradotti}</strong>/{ totaleProdotti }
        </div>
    )
}

export default ProdottiTradotti;